import {
  Alert, Box,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetLiveProjectQuery } from '../../../../../../generated/core-api/graphql-react-query';
import StyledBox from '../DecisionTreeRun/styles';

interface UnauthorizedPageProps {
  projectId?: string;
}

export default function UnauthorizedPage(props: UnauthorizedPageProps) {
  const { projectId } = props;
  const { t } = useTranslation();
  const project = useGetLiveProjectQuery({ input: { id: projectId } }, { enabled: !!projectId });

  return (
    <StyledBox>
      <Box className="content">
        <Alert severity="error">
          {project.data?.getProject.name && (
            <>
              {t('decisionTree.tree.unauthorized-tree-link')}
              <strong>{project.data.getProject.name}</strong>
            </>
          )}
          <Typography>{t('decisionTree.tree.tree-not-found')}</Typography>
        </Alert>
      </Box>
    </StyledBox>
  );
}
